import { parseTemporal } from '@/shared/utils/temporal';
import { isValid, parseISO } from 'date-fns';

export const localeMap: Record<string, string> = {
    de: 'de',
    en: 'en',
    fr: 'fr',
    tr: 'tr',
    zh: 'zh',
    es: 'es',
    pl: 'pl',
    ru: 'ru',
};

export const parseValue = (value: string | null | undefined) => {
    if (value == null || String(value).trim() === '') return null;

    const normalized = parseTemporal(value, 'datetime') ?? parseTemporal(value, 'date');
    if (!normalized) return null;
    const date = parseISO(normalized);
    return isValid(date) ? date : null;
};
